import React, { Component } from "react"
import { Slider, Handles, Tracks, Rail } from "react-compound-slider"
import { SliderRail, Handle, Track } from "./Slider"

export default class PriceFilter extends Component {
  state = {
    show: false,
    domain: this.props.domain,
    values: this.props.domain,
    update: this.props.domain,
  }

  componentDidMount() {
    const existingPriceOpen = JSON.parse(sessionStorage.getItem("price-open"))
    if (existingPriceOpen) {
      if (existingPriceOpen.priceOpen) {
        this.setState({
          show: existingPriceOpen.priceOpen,
        })
      }
    }
  }

  onCollapse = event => {
    const { show } = this.state
    event.preventDefault()
    sessionStorage.setItem("price-open", JSON.stringify({ priceOpen: !show }))
    this.setState({
      show: !show,
    })
  }

  onUpdate = update => {
    this.setState({
      update: update,
    })
  }

  onChange = values => {
    const { onPriceFilterChange } = this.props
    this.setState({
      values: values,
    })
    onPriceFilterChange(values)
  }

  getShow = () => {
    return this.state.show ? " show" : ""
  }

  render() {
    const {
      state: { show, values, update },
      props: { domain, contentMap },
      onCollapse,
      onUpdate,
      onChange,
    } = this

    return (
      <div className="sidebar-block px-3 px-lg-0 mr-lg-4 mb-3">
        <a
          data-toggle="collapse"
          href="#"
          title={contentMap.filter_by_price.value}
          aria-expanded={show}
          aria-controls="priceFilterMenu"
          className="d-lg-none block-toggler"
          onClick={onCollapse}
        >
          {contentMap.filter_by_price.value}
        </a>

        <div
          id="priceFilterMenu"
          className={"expand-lg collapse" + this.getShow()}
        >
          <h6 className="sidebar-heading d-none d-lg-block">
            {contentMap.filter_price.value}
          </h6>

          <div id="priceSlider" className="mt-4 mt-lg-5">
            <Slider
              mode={2}
              step={1}
              domain={domain}
              onUpdate={onUpdate}
              onChange={onChange}
              values={values}
              className="slider-main"
            >
              <Rail>
                {({ getRailProps }) => (
                  <SliderRail getRailProps={getRailProps} />
                )}
              </Rail>
              <Handles>
                {({ handles, getHandleProps }) => (
                  <div className="slider-handles">
                    {handles.map(handle => (
                      <Handle
                        key={handle.id}
                        handle={handle}
                        domain={domain}
                        getHandleProps={getHandleProps}
                      />
                    ))}
                  </div>
                )}
              </Handles>
              <Tracks left={false} right={false}>
                {({ tracks, getTrackProps }) => (
                  <div className="slider-tracks">
                    {tracks.map(({ id, source, target }) => (
                      <Track
                        key={id}
                        source={source}
                        target={target}
                        getTrackProps={getTrackProps}
                      />
                    ))}
                  </div>
                )}
              </Tracks>
            </Slider>
          </div>
          <label htmlFor="priceSlider" className="mt-4">
            € {update[0].toFixed(2)} - € {update[1].toFixed(2)}
          </label>
        </div>
      </div>
    )
  }
}
